<template>
  <div class="software">
    <Item/>
  </div>
</template>

<script>
  import Item from './Item'
  import Package from './Package'

  export default {
    name: 'Software',
    components: {
      Item,
      Package
    },
    data () {
      return {
        page: 'packages'
      }
    },
    methods: {
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Index.vue?31b529b6